import PropTypes from 'prop-types'
import React from 'react'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from 'react-bootstrap'
import Toggle from 'components/Toggle'
import Button from 'components/Button'
import KanBoIcon from 'components/KanBoIcon'
import DateInput from './types/DateInput'

export class Field extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    error: PropTypes.string,
    isFormBusy: PropTypes.bool.isRequired,
    items: PropTypes.array,
    enabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  }

  state = {
    value: this.props.value || '',
    isBusy: false
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.value !== prevProps.value) {
      this.setValue(this.props.value)
    }
  }

  stopChangeCommit = () => {
    if (this.changeCommitTimeout) {
      clearTimeout(this.changeCommitTimeout)
      delete this.changeCommitTimeout
    }
  }

  startChangeCommit = (value, delay = 0) => {
    const { id, onChange } = this.props

    this.stopChangeCommit()

    this.changeCommitTimeout = setTimeout(() => {
      this.setState({
        isBusy: true
      })

      onChange(id, value, () => {
        this.setState({
          isBusy: false
        })
      })
    }, delay)
  }

  clear = () => {
    this.setState({
      value: ''
    })
  }

  setValue = (value) => {
    this.setState({
      value
    })
  }

  handleChange = (value) => {
    this.setValue(value)
  }

  handleInputChange = (event) => {
    this.handleChange(event.target.value)

    if (event.target.value !== this.props.value) {
      this.startChangeCommit(event.target.value, 1000)
    }
  }

  handleInputBlur = (event) => {
    if (event.target.value !== this.props.value) {
      this.startChangeCommit(event.target.value)
    }
  }

  handleCheckboxChange = (value) => {
    value = value.toString()

    this.handleChange(value)

    this.startChangeCommit(value)
  }

  handleSelectChange = (event) => {
    this.handleChange(event.target.value)

    this.startChangeCommit(event.target.value)
  }

  handleButtonClick = () => {
    this.startChangeCommit(this.state.value)
  }

  handleDateChange = (value) => {
    this.handleChange(value)

    this.startChangeCommit(value)
  }

  renderFormControl = () => {
    const {
      type,
      items,
    } = this.props
    const {
      value
    } = this.state

    switch (type) {
      case 'TEXT':
        return (
          <FormControl
            type='text'
            value={value}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
          />
        )
      case 'PASSWORD':
        return (
          <FormControl
            type='password'
            value={value}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
          />
        )
      case 'URL':
        return (
          <FormControl
            type='url'
            value={value}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
          />
        )
      case 'EMAIL':
        return (
          <FormControl
            type='email'
            value={value}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
          />
        )
      case 'DATE':
        return <DateInput {...this.props} onChange={this.handleDateChange} />
      case 'INTERVAL':
        return (
          <FormControl componentClass='select'>
            <option value={1}>{'1 minute'}</option>
            <option value={15}>{'15 minutes'}</option>
            <option value={60}>{'1 hour'}</option>
            <option value={120}>{'2 hours'}</option>
            <option value={720}>{'12 hours'}</option>
            <option value={1440}>{'24 hours'}</option>
          </FormControl>
        )
      case 'CHECKBOX':
        return (
          <div>
            <Toggle
              checked={value === 'true'}
              onChange={this.handleCheckboxChange}
            />
          </div>
        )
      case 'SELECT':
        return (
          <FormControl
            componentClass='select'
            value={value}
            onChange={this.handleSelectChange}
          >
            {items.map(item =>
              <option key={item.value} value={item.value}>{item.text}</option>
            )}
          </FormControl>
        )
      default:
        return (
          <div>
            {`UNKNOWN FIELD TYPE: ${type}`}
          </div>
        )
    }
  }

  render = () => {
    const {
      type,
      name,
      value: defaultValue,
      error,
      isFormBusy,
      enabled,
    } = this.props
    const {
      value,
      isBusy
    } = this.state

    if (type === 'HIDDEN') {
      return null
    } else {
      const showError = !isFormBusy && error && value === defaultValue

      if (type === 'BUTTON') {
        return (
          <FormGroup validationState={showError ? 'error' : null}>
            <Button
              disabled={!enabled}
              onClick={this.handleButtonClick}
            >
              {name}
            </Button>
            {isBusy && <KanBoIcon spin name='kanbo-16-loading' style={{ marginLeft: '0.5em' }} />}
            {showError && <HelpBlock>{error}</HelpBlock>}
          </FormGroup>
        )
      } else if (type === 'CAPTION') {
        return (
          <FormGroup validationState={showError ? 'error' : null}>
            <FormControl.Static>{name}</FormControl.Static>
            {isBusy && <KanBoIcon spin name='kanbo-16-loading' />}
            {showError && <HelpBlock>{error}</HelpBlock>}
          </FormGroup>
        )
      }

      return (
        <FormGroup validationState={showError ? 'error' : null}>
          <ControlLabel>
            {name}
            {' '}
            {isBusy && <KanBoIcon spin name='kanbo-16-loading' />}
          </ControlLabel>
          {this.renderFormControl()}
          {showError && <HelpBlock>{error}</HelpBlock>}
        </FormGroup>
      )
    }
  }
}

export default Field
